var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224,52H32A12.01343,12.01343,0,0,0,20,64V88a12.01343,12.01343,0,0,0,12,12h4v92a12.01343,12.01343,0,0,0,12,12H208a12.01343,12.01343,0,0,0,12-12V100h4a12.01343,12.01343,0,0,0,12-12V64A12.01343,12.01343,0,0,0,224,52ZM212,192a4.00427,4.00427,0,0,1-4,4H48a4.00427,4.00427,0,0,1-4-4V100H212ZM228,88a4.00427,4.00427,0,0,1-4,4H32a4.00427,4.00427,0,0,1-4-4V64a4.00427,4.00427,0,0,1,4-4H224a4.00427,4.00427,0,0,1,4,4ZM100,136a4.0002,4.0002,0,0,1,4-4h48a4,4,0,0,1,0,8H104A4.0002,4.0002,0,0,1,100,136Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveBold);
export default __webpack_public_path__ + "static/media/archive-bold.c839b4e436d344727d2d34d8d0cdf204.svg";
export { ForwardRef as ReactComponent };